const EIN_DIGITS_LENGTH = 9;

export const normalizeEin = (value: string | undefined): string => value ? value.replace(/\D/g, '').slice(0, EIN_DIGITS_LENGTH) :  '';

export const formatEin = (value: string | undefined): string => {
  const digits = normalizeEin(value);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
};

export const isValidEin = (value: string | undefined): boolean => normalizeEin(value).length === EIN_DIGITS_LENGTH;

export const getCommonFieldProps = (disabled?: boolean) => ({
  fullWidth: true,
  disabled: !!disabled,
});

export const getCommonSelectProps = (disabled?: boolean) => ({
  ...getCommonFieldProps(disabled),
  MenuProps: { disableScrollLock: true },
});

export const getCommonFormControlProps = (disabled?: boolean) => ({
  fullWidth: true,
  disabled: !!disabled,
});


